import { Box, Skeleton, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { EmptyState } from '@/components/EmptyState';
import useUserDetails from '@/hooks/useUserDetails';
import generateSkeletonKeys from '@/utils/generateSkeletonKeys';

import { FeedFilters, fetchFeedData } from './api/fetchFeedData';
import { FeedRow } from './components/FeedRow';

const skeletonKeys = generateSkeletonKeys(10);
export const Feed = ({ metadata }: { metadata?: FeedFilters }) => {
  const { isUserExpired } = useUserDetails();

  const { data, isLoading } = useQuery({
    queryKey: ['feed', metadata],
    queryFn: () => fetchFeedData(metadata),
    refetchInterval: 10000,
    enabled: !isUserExpired
  });

  return (
    <Box
      sx={{
        px: '8px',
        py: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        maxHeight: '650px',
        minHeight: '200px',
        overflowY: 'auto'
      }}
    >
      {isUserExpired ? (
        <Box sx={{ display: 'flex', flexGrow: 1, justifyContent: 'center', alignItems: 'center' }}>
          <Typography sx={{ textAlign: 'center' }}>
            You no longer have access.
            <br />
            Please upgrade to access Feed.
          </Typography>
        </Box>
      ) : (
        <>
          {isLoading &&
            skeletonKeys.map(row => (
              <Skeleton
                key={row}
                height='23px'
                width='100%'
              />
            ))}

          {data?.length === 0 && <EmptyState />}

          {data?.map(row => (
            <FeedRow
              key={row.transactionTime + row.values.Title}
              {...row}
            />
          ))}
        </>
      )}
    </Box>
  );
};
